import React from 'react';

const Error = ({ details }) => (
  <div className="panel panel-default error">
    <p>Something went wrong, Please contact the front desk!</p>
  </div>
);

export default Error;
